var _symbol, _symbol2, _symbol3, _symbol4, _symbol5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e3ffa8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.286,
    d: "m26.56 11.933-8.693 8.693a2.647 2.647 0 0 1-3.733 0l-8.693-8.693",
    style: {
      stroke: "var(--color1, #e3ffa8)"
    }
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-basket",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M12 4h8m-6.667 10v6.667M18.667 14v6.667M4 8h24m-2.667 0-.935 14.026c-.14 2.104-.21 3.156-.665 3.954a4.007 4.007 0 0 1-1.731 1.62c-.826.4-1.881.4-3.99.4h-4.025c-2.109 0-3.163 0-3.99-.4a3.996 3.996 0 0 1-1.731-1.62c-.455-.798-.525-1.85-.665-3.954L6.666 8"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bottle-of-water",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b6c3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M24 20v5.333c0 2.2-1.8 4-4 4h-8c-2.2 0-4-1.8-4-4V18.64l5.187.027c.973 0 1.933.227 2.813.667s1.84.667 2.827.667H24z",
    style: {
      stroke: "var(--color2, #b6c3ff)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b6c3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M24 14.44V20h-5.173c-.987 0-1.947-.227-2.827-.667s-1.84-.667-2.813-.667L8 18.639v-4.2c0-.613.347-1.453.787-1.893l2.827-2.827c.24-.24.387-.587.387-.933v-2.12h8v2.12c0 .347.147.693.387.933l2.827 2.827c.44.44.787 1.28.787 1.893z",
    style: {
      stroke: "var(--color2, #b6c3ff)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b6c3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M24 21.333V20M8 19.973V18.64",
    style: {
      stroke: "var(--color2, #b6c3ff)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b6c3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M19.333 6.667h-6.667c-1.107 0-2-.907-2-2s.893-2 2-2h6.667c1.107 0 2 .907 2 2s-.893 2-2 2z",
    style: {
      stroke: "var(--color2, #b6c3ff)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calories-bubble",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#45ffbc",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    d: "M20.786 16.347c3.778 0 6.84-3.062 6.84-6.84s-3.062-6.84-6.84-6.84-6.84 3.062-6.84 6.84 3.062 6.84 6.84 6.84zM8.48 25.92a4.107 4.107 0 1 0 0-8.215 4.107 4.107 0 0 0 0 8.215zM22.16 29.333a3.413 3.413 0 1 0 0-6.826 3.413 3.413 0 0 0 0 6.826z",
    style: {
      stroke: "var(--color3, #45ffbc)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close-circle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b6b6b6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.999 29.333c7.333 0 13.333-6 13.333-13.333s-6-13.333-13.333-13.333S2.666 8.667 2.666 16s6 13.333 13.333 13.333zM12.227 19.773l7.547-7.547M19.773 19.773l-7.547-7.547",
    style: {
      stroke: "var(--color4, #b6b6b6)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-download-avatar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e3ffa8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 2.667V12l2.667-2.667M16.001 12l-2.667-2.667M2.641 17.333h5.88c.507 0 .96.28 1.187.733l1.56 3.12a2.665 2.665 0 0 0 2.387 1.48h4.707a2.668 2.668 0 0 0 2.387-1.48l1.56-3.12a1.333 1.333 0 0 1 1.187-.733h5.813",
    style: {
      stroke: "var(--color1, #e3ffa8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e3ffa8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.333 5.507c-4.72.693-6.667 3.467-6.667 9.16V20c0 6.667 2.667 9.333 9.333 9.333h8c6.667 0 9.333-2.667 9.333-9.333v-5.333c0-5.693-1.947-8.467-6.667-9.16",
    style: {
      stroke: "var(--color1, #e3ffa8)"
    }
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17.679 4.8 6.732 16.387c-.413.44-.813 1.307-.893 1.907l-.493 4.32c-.173 1.56.947 2.627 2.493 2.36l4.293-.733c.6-.107 1.44-.547 1.853-1l10.947-11.587c1.893-2 2.747-4.28-.2-7.067-2.933-2.76-5.16-1.787-7.053.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M15.854 6.733a8.169 8.169 0 0 0 7.267 6.867M4 29.333h24"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-header-login-Logout-Icon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714,
    d: "M16.159 17.04a1.316 1.316 0 0 0-.32 0 4.358 4.358 0 0 1-4.213-4.36 4.367 4.367 0 0 1 4.373-4.373 4.376 4.376 0 0 1 4.373 4.373 4.368 4.368 0 0 1-4.213 4.36zM24.987 25.84c-2.373 2.173-5.52 3.493-8.987 3.493s-6.613-1.32-8.987-3.493c.133-1.253.933-2.48 2.36-3.44 3.653-2.427 9.627-2.427 13.253 0 1.427.96 2.227 2.187 2.36 3.44z",
    style: {
      stroke: "var(--color5, #fff)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714,
    d: "M16 29.333c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333z",
    style: {
      stroke: "var(--color5, #fff)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.867 10.08c.413-4.8 2.88-6.76 8.28-6.76h.173c5.96 0 8.347 2.387 8.347 8.347v8.693c0 5.96-2.387 8.347-8.347 8.347h-.173c-5.36 0-7.827-1.933-8.267-6.653M20 16H4.827M7.801 11.533 3.334 16l4.467 4.467",
    style: {
      stroke: "var(--color5, #fff)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-header-mobile",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e3ffa8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M23.386 11.08a3.28 3.28 0 1 0 0-6.56 3.28 3.28 0 0 0 0 6.56zM8.613 11.08a3.28 3.28 0 1 0 0-6.56 3.28 3.28 0 0 0 0 6.56zM23.386 27.48a3.28 3.28 0 1 0 0-6.56 3.28 3.28 0 0 0 0 6.56zM8.613 27.48a3.28 3.28 0 1 0 0-6.56 3.28 3.28 0 0 0 0 6.56z",
    style: {
      stroke: "var(--color1, #e3ffa8)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-settings",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    style: {
      stroke: "var(--color5, #fff)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M2.666 17.173v-2.347a2.54 2.54 0 0 1 2.533-2.533c2.413 0 3.4-1.707 2.187-3.8-.693-1.2-.28-2.76.933-3.453l2.307-1.32c1.053-.627 2.413-.253 3.04.8l.147.253c1.2 2.093 3.173 2.093 4.387 0l.147-.253c.627-1.053 1.987-1.427 3.04-.8l2.307 1.32a2.531 2.531 0 0 1 .933 3.453c-1.213 2.093-.227 3.8 2.187 3.8a2.54 2.54 0 0 1 2.533 2.533v2.347a2.54 2.54 0 0 1-2.533 2.533c-2.413 0-3.4 1.707-2.187 3.8a2.529 2.529 0 0 1-.933 3.453l-2.307 1.32c-1.053.627-2.413.253-3.04-.8l-.147-.253c-1.2-2.093-3.173-2.093-4.387 0l-.147.253c-.627 1.053-1.987 1.427-3.04.8l-2.307-1.32a2.531 2.531 0 0 1-.933-3.453c1.213-2.093.227-3.8-2.187-3.8a2.54 2.54 0 0 1-2.533-2.533z",
    style: {
      stroke: "var(--color5, #fff)"
    }
  })), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-add",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M8 16h16M16 24V8"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b6b6b6",
    style: {
      stroke: "var(--color1, #b6b6b6)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3333,
    d: "M12.76 7.907l-8.093 8.093 8.093 8.093"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b6b6b6",
    style: {
      stroke: "var(--color1, #b6b6b6)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3333,
    d: "M27.333 16h-22.44"
  })), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.293 5.293l-10.293 10.293-4.293-4.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l5 5c0.391 0.391 1.024 0.391 1.414 0l11-11c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-x",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e3ffa8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m26.56 20.066-8.693-8.693a2.647 2.647 0 0 0-3.733 0l-8.693 8.693",
    style: {
      stroke: "var(--color1, #e3ffa8)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.88b4d86df4832152653d3af917ac190e.svg";
export { ForwardRef as ReactComponent };